import React, {useState} from "react";
import Switch from "react-bootstrap-switch";
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {connect, useSelector} from "react-redux";
import {useForm} from "react-hook-form";


// components
import SelectGeneric from "../../../components/select/selectGeneric";
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";

// labels
import {LB_CODE, LB_ACTIVE, LB_CATEGORY} from "../../../components/i18n/i18n";
import {PH_CODE, } from "../../../components/i18n/placeHolders";

// actions
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";

// providers
import {hotelCategoryProvider} from "../../../providers/hotelCategoryProvider";




const RoomTypeFilters = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { udn, filter, app } = componentState?.data || {};
    const fbDataBase = {id: app?.fbDataBase?.id}

    const [status, setStatus] = useState(filter?.status || null);
    const [categoryId, setCategoryId] = useState(filter?.categoryId || null);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            code: filter?.code || ''
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase,
            item : {  ...data, }
        };

        if (status !== undefined && status !== null)
            dataFilter.item.status = status;

        if (categoryId !== undefined && categoryId !== null && categoryId !== '')
            dataFilter.item.category = { id : categoryId };

        if (udn !== undefined && udn !== null)
            dataFilter.item.udn = { id : udn?.id };

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        setStatus(null)
        reset({
            name: ''
        });
    }

    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <CardBody>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>{LB_CATEGORY}</Label>
                        <SelectGeneric
                            initialValue={ categoryId }
                            setExternalValue={ setCategoryId }
                            provider = { hotelCategoryProvider }
                            getAllCategories={true}
                        />
                    </FormGroup>
                </Col>

                <Col md="4">
                    <FormGroup>
                        <Label>{LB_CODE}</Label>
                        <Input
                            type="text"
                            name="code"
                            placeholder={PH_CODE}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>

                <Col md="2">
                    <FormGroup>
                        <Label>{LB_ACTIVE}</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={status}
                            onChange={ () => setStatus(!status) }
                        />
                    </FormGroup>
                </Col>
                <Col sm={12} className={'d-flex justify-content-center'}>
                    <div className="float-right ">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(RoomTypeFilters)